import { Button } from '@radix-ui/themes';
import { useTranslation } from 'react-i18next';
import Title from '../../elements/Title';
import BackToHubert from '../../navbar/BackToHubert';

const Error404 = () => {
  const { t } = useTranslation();
  return (
    <div className="vh-100 flex items-center justify-center">
      <Title title={t('notFound.pageTitle')} />
      <BackToHubert />
      <div className="w-3/4 pb-12 shadow-lg text-center" style={{ maxWidth: '25rem' }}>
        <img src="/logo/hubert_logo_lockup_dark@2x.png" alt={t('notFound.logo.alt')} className="mw-100" />
        <h1 style={{ fontSize: '9em', fontWeight: '600' }}>404</h1>
        <span style={{ fontSize: '5rem', fontWeight: '100' }}>{t('notFound.oops')}</span>
        <p>{t('notFound.message')}</p>
        <a href="/">
          <Button size="3" className="m-4">
            {t('notFound.backButton')}
          </Button>
        </a>
      </div>
    </div>
  );
};

export default Error404;
